const ServicesData = [
    {
      titleEN: 'Web Design',
      titleAr: 'تصميم الويب',
      descEn: 'We create stunning, user-friendly designs that reflect your brand and engage your audience.',
      descAr: 'نقوم بإنشاء تصاميم رائعة وسهلة الاستخدام تعكس علامتك التجارية وتشد جمهورك',
    },
    {
      titleEN: 'Frontend Development',
      titleAr: 'تطوير الواجهة الأمامية',
      descEn: 'Our frontend developers use the latest technologies to build responsive and interactive user interfaces.',
      descAr: 'يستخدم مطورونا الأماميون أحدث التقنيات لبناء واجهات مستخدم مستجيبة وتفاعلية.',
    },
    {
      titleEN: 'Backend Development',
      titleAr: 'تطوير الجزء الخلفي',
      descEn: 'Our backend developers ensure your website operates smoothly, handling databases, server-side logic, and more.',
      descAr: 'يضمن مطورونا الخلفيون سلاسة تشغيل موقع الويب الخاص بك، معالجة قواعد البيانات والمنطق الخادم وأكثر من ذلك.',
    },
    {
      titleEN: 'Full Stack Development',
      titleAr: 'تطوير الشامل',
      descEn: 'We offer end-to-end development services, covering both frontend and backend aspects to deliver a complete solution.',
      descAr: 'نقدم خدمات تطوير شاملة تغطي جوانب الواجهة الأمامية والجزء الخلفي لتقديم حلول كاملة.',
    },
    {
      titleEN: 'E-commerce Solutions',
      titleAr: 'حلول التجارة الإلكترونية',
      descEn: 'We build custom e-commerce platforms tailored to your business needs, with secure payment gateways and intuitive user experiences.',
      descAr: 'نقوم ببناء منصات التجارة الإلكترونية المخصصة حسب احتياجات عملك، مع بوابات دفع آمنة وتجارب مستخدم سهلة.',
    },
    {
      titleEN: 'SEO',
      titleAr: 'تحسين محركات البحث',
      descEn: 'Elevate your online presence with our SEO service, expertly designed to boost your website\'s visibility and drive organic traffic.',
      descAr: 'زيادة وجودك على الإنترنت مع خدمة تحسين محركات البحث الخاصة بنا، مصممة بمهارة لزيادة رؤية موقع الويب الخاص بك ودفع حركة المرور العضوية.',
    }
  ];
  export default ServicesData;
  